var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tender-container" },
    [
      _c("discard-changes", { ref: "discardAlert" }),
      _vm._v(" "),
      _c(
        "tender-head",
        {
          ref: "tenderEditHead",
          attrs: { tenderGeneral: _vm.currentTender.general },
        },
        [
          _vm.isPicView || _vm.isRepresentative
            ? [
                !_vm.isEditing
                  ? _c(
                      "button",
                      {
                        directives: [
                          {
                            name: "note",
                            rawName: "v-note",
                            value: {
                              text: _vm.noteText,
                              enable: !_vm.editable,
                            },
                            expression: "{text:noteText, enable:!editable}",
                          },
                        ],
                        staticClass: "btn btn--darkblue",
                        attrs: {
                          type: "button",
                          disabled: !_vm.editable || _vm.isTenderRepEditing,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.goEdit()
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("action.edit")))]
                    )
                  : [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn--darkblue",
                          attrs: { type: "button", disabled: !_vm.isPageDirty },
                          on: {
                            click: function ($event) {
                              return _vm.openModal()
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("action.discard")))]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          directives: [
                            { name: "hkldreset", rawName: "v-hkldreset" },
                          ],
                          staticClass: "btn btn--orange",
                          attrs: { type: "button", disabled: _vm.disableSave },
                          on: {
                            click: function ($event) {
                              return _vm.save()
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("action.save")))]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          directives: [
                            { name: "hkldreset", rawName: "v-hkldreset" },
                          ],
                          staticClass: "btn btn--orange",
                          attrs: { type: "button", disabled: _vm.disableSave },
                          on: {
                            click: function ($event) {
                              return _vm.submit()
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.previewButtonName))]
                      ),
                    ],
              ]
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _vm.isEditing
        ? _c(
            "TenderTabsContainer",
            { attrs: { isTender: _vm.isTender, tabsInvalid: _vm.tabsInvalid } },
            [
              _vm.isPicView || _vm.isRepresentative
                ? [
                    _c(
                      "button",
                      {
                        staticClass:
                          "btn btn--darkblue tender-sticky-button mini-btn",
                        attrs: { type: "button", disabled: !_vm.isPageDirty },
                        on: {
                          click: function ($event) {
                            return _vm.openModal()
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("action.discard")))]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        directives: [
                          { name: "hkldreset", rawName: "v-hkldreset" },
                        ],
                        staticClass:
                          "btn btn--orange tender-sticky-button mini-btn",
                        attrs: { type: "button", disabled: _vm.disableSave },
                        on: {
                          click: function ($event) {
                            return _vm.save()
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("action.save")))]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        directives: [
                          { name: "hkldreset", rawName: "v-hkldreset" },
                        ],
                        staticClass:
                          "btn btn--orange tender-sticky-button mini-btn",
                        attrs: { type: "button", disabled: _vm.disableSave },
                        on: {
                          click: function ($event) {
                            return _vm.submit()
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.previewButtonName))]
                    ),
                  ]
                : _vm._e(),
              _vm._v(" "),
              _c("General", {
                ref: "general_tab",
                attrs: { slot: "general", isTender: _vm.isTender },
                slot: "general",
              }),
              _vm._v(" "),
              _c("ScopeOfWorkEditor", {
                attrs: { slot: "scopeOfWork" },
                slot: "scopeOfWork",
              }),
              _vm._v(" "),
              _c("ItemsServices", {
                ref: "items_services_tab",
                attrs: { slot: "itemServices", lockItems: _vm.lockItems },
                slot: "itemServices",
              }),
              _vm._v(" "),
              _c("FileUpload", {
                ref: "file_uploader_tab",
                attrs: {
                  slot: "fileUpload",
                  attachment: _vm.attachment,
                  showTenderHints: true,
                  metaData: { category: undefined },
                  resourceId: _vm.currentTender.general.id,
                  overallDescription: true,
                },
                on: {
                  "update:attachment": function ($event) {
                    _vm.attachment = $event
                  },
                },
                slot: "fileUpload",
              }),
              _vm._v(" "),
              _c("TermsConditions", {
                attrs: {
                  slot: "termsConditions",
                  isTender: _vm.isTender,
                  zipName: _vm.zipNames.terms,
                },
                slot: "termsConditions",
              }),
            ],
            2
          )
        : _c(
            "TenderTabsContainer",
            { attrs: { isTender: _vm.isTender } },
            [
              _vm.isPicView || _vm.isRepresentative
                ? _c(
                    "button",
                    {
                      directives: [
                        {
                          name: "note",
                          rawName: "v-note",
                          value: { text: _vm.noteText, enable: !_vm.editable },
                          expression: "{text:noteText, enable:!editable}",
                        },
                      ],
                      staticClass: "btn btn--darkblue",
                      attrs: { type: "button", disabled: !_vm.editable },
                      on: {
                        click: function ($event) {
                          return _vm.goEdit()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("action.edit")))]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.tenderId === _vm.currentTender.general.id
                ? _c("GeneralView", {
                    attrs: { slot: "general" },
                    slot: "general",
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("ScopeOfWork", {
                attrs: { slot: "scopeOfWork" },
                slot: "scopeOfWork",
              }),
              _vm._v(" "),
              _c("ItemsServicesView", {
                attrs: { slot: "itemServices" },
                slot: "itemServices",
              }),
              _vm._v(" "),
              _c("Attachments", {
                attrs: {
                  slot: "fileUpload",
                  files: _vm.attachmentFiles,
                  description: _vm.attachment.description,
                  zipName: _vm.zipNames.attachments,
                },
                slot: "fileUpload",
              }),
              _vm._v(" "),
              _c("TermsConditions", {
                attrs: {
                  slot: "termsConditions",
                  tenderId: _vm.tenderId,
                  isTender: _vm.isTender,
                  zipName: _vm.zipNames.terms,
                },
                slot: "termsConditions",
              }),
            ],
            1
          ),
      _vm._v(" "),
      _c("TenderRepresentative", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showTenderRep,
            expression: "showTenderRep",
          },
        ],
        attrs: { isEditing: _vm.isTenderRepEditing },
        on: {
          "update:isEditing": function ($event) {
            _vm.isTenderRepEditing = $event
          },
          "update:is-editing": function ($event) {
            _vm.isTenderRepEditing = $event
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }